export const CREATE_PSEUDONYM_REQUEST = 'CREATE_PSEUDONYM_REQUEST';

export const createPseudonymRequest = ( pseudonymData ) => ({
    type: CREATE_PSEUDONYM_REQUEST,
    payload: { ...pseudonymData },
});
